import script from "./ActivityBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityBanner.vue?vue&type=script&setup=true&lang=js"

import "./ActivityBanner.vue?vue&type=style&index=0&id=010dc5a9&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_0435b427d4926b97c683d68ac9fd935c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-010dc5a9"]])

export default __exports__